import React, { useState, useEffect } from 'react';
import './Navbar.scss';
import logo from '../../assets/logo.jpg';

const navLinks = [
  { label: 'Products',     href: '/#materialHandling' },
  { label: 'About',        href: '/#about'          },
  { label: 'Projects',     href: '/#projects'       },
  { label: 'Clients',      href: '/#clients'        },
  { label: 'Testimonials', href: '/#testimonials'   },
  { label: 'Contact',      href: '/#contact'        },
];

const Navbar = () => {
  const [scrolled,    setScrolled]    = useState(false);
  const [menuOpen,    setMenuOpen]    = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className={`navbar-custom ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="d-flex align-items-center justify-content-between">

          {/* Brand */}
          <a href="/#hero" className="brand" onClick={closeMenu}>
            <div className="brand-icon">
              <img src={logo} alt="Aavjo Industries" />
            </div>
            <div className="brand-text">
              <div className="brand-name">Aavjo</div>
              <div className="brand-tagline">Industry</div>
            </div>
          </a>

          {/* Desktop nav */}
          <ul className="nav-links d-none d-lg-flex">
            {navLinks.map(link => (
              <li key={link.href}>
                <a href={link.href}>{link.label}</a>
              </li>
            ))}
          </ul>

          {/* Desktop CTA */}
          <a href="/#contact" className="nav-cta d-none d-lg-flex">
            Get a Quote
          </a>

          {/* Mobile hamburger */}
          <button
            className={`hamburger d-lg-none ${menuOpen ? 'open' : ''}`}
            onClick={() => setMenuOpen(prev => !prev)}
            aria-label="Toggle navigation"
          >
            <span /><span /><span />
          </button>
        </div>
      </div>

      {/* Mobile drawer */}
      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        {navLinks.map(link => (
          <a key={link.href} href={link.href} onClick={closeMenu}>
            {link.label}
          </a>
        ))}
        <a href="/#contact" className="mobile-cta" onClick={closeMenu}>
          Get a Quote
        </a>
      </div>

      {/* Overlay */}
      <div
        className={`overlay ${menuOpen ? 'visible' : ''}`}
        onClick={closeMenu}
      />
    </nav>
  );
};

export default Navbar;
